function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
    // 生成随机时间
    function generateRandomTime() {
      var hours = Math.floor(Math.random() * 15) + 1
      var minutes = Math.floor(Math.random() * 60)
      var seconds = Math.floor(Math.random() * 60)
      //总共的毫秒数
      var targetTime = (hours * 3600 + minutes * 60 + seconds) * 1000

      return targetTime
    }
    function TimeDown(value) {
      //倒计时的总秒数
      var totalSeconds = parseInt(value / 1000)
      //取模（余数）
      var modulo = totalSeconds % (60 * 60 * 24)
      //小时数
      var hours = Math.floor(modulo / (60 * 60))
      modulo = modulo % (60 * 60)
      //分钟
      var minutes = Math.floor(modulo / 60)
      //秒
      var seconds = modulo % 60

      hours = hours.toString().length == 1 ? '0' + hours : hours
      minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
      seconds = seconds.toString().length == 1 ? '0' + seconds : seconds

      //输出到页面
      $('.sp_hour').html(hours)
      $('.sp_minute').html(minutes)
      $('.sp_second').html(seconds)
      //延迟一秒执行自己
      if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
      } else {
        setTimeout(function () {
          TimeDown(value - 1000)
        }, 1000)
      }
    }
    TimeDown(generateRandomTime())
    // 头部固定
    $('header').addClass('stiky')
    $(document).scroll(function (e) {
      setTimeout(function () {
        $('header').addClass('stiky')
      }, 50)
    })
    new Swiper('.mySwiper', {
      loop: true,
      direction: 'vertical',
      autoplay: {
        delay: 2000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
    })
    new Swiper('.mySwiper2', {
      loop: true,
      autoplay: {
        delay: 2000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
      },
    })
    new Swiper('#swiper', {
      loop: true,
      centeredSlides: true,
      spaceBetween: 50,
      slidesPerView: 'auto',
      freeMode: true,
      speed: 5500, //匀速时间
      autoplay: {
        delay: 0,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
    })
    var swiper2 = new Swiper('.mySwiper3', {
      spaceBetween: 0,
      slidesPerView: 3,
      watchSlidesVisibility: true, //防止不可点击
      direction: 'vertical',
      on: {
        click: function () {
          var index = this.clickedIndex
          var indexs = 0
          if (index >= 0 && index <= 4) {
            $('#color .option')
              .eq(0)
              .addClass('active')
              .siblings()
              .removeClass('active')
            if (index == 0) {
              indexs = 1
            } else if (index == 4) {
              indexs = 0
            } else {
              indexs = index + 1
            }
            $('#Size .option')
              .eq(indexs)
              .addClass('active')
              .siblings()
              .removeClass('active')
            $('.top-product>span').html(textArr[index])
          } else if (index <= 9) {
            $('#color .option')
              .eq(1)
              .addClass('active')
              .siblings()
              .removeClass('active')
            if (index == 5) {
              indexs = 1
            } else if (index == 9) {
              indexs = 0
            } else {
              indexs = index - 4
            }
            $('#Size .option')
              .eq(indexs)
              .addClass('active')
              .siblings()
              .removeClass('active')
            $('.top-product>span').html(textArr[index])
          }
        },
      },
    })
    var swiper3 = new Swiper('.mySwiper4', {
      noSwiping: true,
      thumbs: {
        swiper: swiper2,
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
    })
    var textArr = [
      'Standard - Set A',
      'Standard - Set B',
      'Standard - Set C',
      'Standard - Set D',
      'Standard - Set E',
      'Upgraded - Set A',
      'Upgraded - Set B',
      'Upgraded - Set C',
      'Upgraded - Set D',
      'Upgraded - Set E',
    ]
    //加减
    let prods = window.product
     function formatPrice(value) {
    return Math.round(value).toLocaleString('en');
  }
    function getCur(){
      let color = $('#color div.active').attr('data-val')
      let size = $('#Size div.active').attr('data-val')
      return prods.filter(item=> item.option1 == color && item.option2 == size)[0]
    }
    function changePrice(){
      let num = $('#calcNumber').val()
      let price = formatPrice((getCur().price * num / 100).toFixed(0))
      let compare = formatPrice((getCur().compare_at_price * num / 100).toFixed(0))
      // price = (price + '').replace('.', ',')
      // compare = (compare + '').replace('.', ',')
      $('#new').html(price)
      $('#old').html(compare)
      let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
      $(".product-part .sp-frees p .off-num").html(`${off_font}`)
    }
    $('.reduce').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) - 1
      if (num > 0) {
        input.value = num
      }
      var number = Number($('#calcNumber').val())
      changePrice()
    })
    $('.add').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) + 1
      input.value = num
      var number = Number($('#calcNumber').val())
      changePrice()
    })

    // style选项
    let typeOptions = $('#color .option')
    let typeOptions2 = $('#Size .option')
    // 切换选项
    typeOptions.click(function () {
      let index = $(this).index()
      var index2 = $('#Size .option.active').index()
      $(this).addClass('active').siblings().removeClass('active')
      chageOption(index, index2)
    })
    typeOptions2.click(function () {
      let index = $('#color .option.active').index()
      var index2 = $(this).index()
      $(this).addClass('active').siblings().removeClass('active')
      chageOption(index, index2)
    })
    function chageOption(index, index2) {
      if (index == 0) {
        if (index2 == 0) {
          $('.top-product>span').html(textArr[4])
          swiper3.slideTo(0, 1000, false)
        } else {
          $('.top-product>span').html(textArr[index2 - 1])
          swiper3.slideTo(index2 , 1000, false)
        }
      } else if (index == 1) {
        if (index2 == -1) {
          $('.top-product>span').html(textArr[5])
          swiper3.slideTo(5, 1000, false)
        } else if (index2 == 0) {
          $('.top-product>span').html(textArr[9])
          swiper3.slideTo(9, 1000, false)
        } else {
          $('.top-product>span').html(textArr[index2 + 4])
          swiper3.slideTo(index2 + 4, 1000, false)
        }
      }
      changePrice()
    }
    $('.sp-btn-style').click(function(){
      let num = $('#calcNumber').val()
      window.location.href = '/cart/' + getCur().id + ':' + num
    })
    addCart()
    let initNum = 0
    function addCart() {
      // 加入购物车
      $('#addCart').click(function () {
        // do something here
        var data = {
        id: getCur().id,
        quantity: $('#calcNumber').val(),
      };
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
            $("#cardNum").html(result.item_count);
            if (result.item_count > 0) {
              $('.sp-cart .num').css('background', '#cf0101')
            } else {
              $('.sp-cart .num').css('background', '#919191')
            }
          });
        },
        dataType: "json",
      });
        var indexs = swiper3.activeIndex
        var img = $(
          '.mySwiper4 .swiper-wrapper .swiper-slide:eq(' + indexs + ')>img'
        )
        var flyer = img[0].cloneNode(true)
        flyer.classList.add('clone')
        $('.sp-part5').append(flyer)
        $('.clone').css({
          width: '694px',
          height: '800px',
          position: 'fixed',
          top: img[0].offsetTop,
          left: img.offset().left,
          'z-index': '99',
        })
        var offset = $('.sp-cart')[0].getBoundingClientRect()
        $('.sp-cart').addClass('shake')
        setTimeout(() => {
          $('.sp-cart').removeClass('shake')
        }, 1000)
        let finish = $('.sp-cart')
        $('.clone').animate(
          {
            top: finish[0].offsetTop + 117,
            left: finish[0].offsetLeft + finish.width() / 2,
            width: 50, // 结束时的大小，根据需要调整
            height: 50, // 结束时的大小，根据需要调整
            opacity: 0.4,
          },
          1000,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach() // 完成动画后移除克隆的图片
              }
            )
          }
        )
      })
    }
  })
  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image()
        img.src = url
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    // preloadImages(imagesOneDim)
    // preloadImages(imagesTwoDim)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop =
          targetElement.offsetTop 
        window.scroll({
          top: offsetTop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }
}

mainRender()
